import React from 'react';
import { CustomFieldContract } from '../../../types/CustomField';
import CustomFieldList, { CustomFieldListData } from '../CustomFieldList';

export const CustomFieldFormTestId = 'CustomFieldForm-framework';

export type CustomFieldFormProps = {
  customFields: CustomFieldContract[];
  onValidData: (id: number, value: string) => void;
  onErrorStatus?: (hasError: boolean) => void;
  useContext?: boolean;
};

const CustomFieldForm: React.FC<CustomFieldFormProps> = ({
  customFields,
  onValidData,
  onErrorStatus,
  useContext,
}: CustomFieldFormProps) => {
  const handleOnValidData = (customFieldData: CustomFieldListData): void => {
    const { id, value } = customFieldData;
    onValidData(id, value);
  };
  return (
    <div data-testid={CustomFieldFormTestId}>
      <CustomFieldList
        customFields={customFields}
        onValidData={handleOnValidData}
        onErrorStatus={onErrorStatus}
        useContext={useContext}
      />
    </div>
  );
};

export default CustomFieldForm;
